import styled from "styled-components";

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
  border-bottom: 2px solid ${(props) => props.theme.fontColor};
  margin-right: 10px;
`;


export const PaymentWrapper = styled.div`
  width: 100%;
  overflow: auto;
  padding-bottom: 16px;
`;

export const PaymentTable = styled.table`
  width: 100%;
  &,
  td {
    border: 1px solid ${(props) => props.theme.fontColor};
  }

  td {
    text-align: center;
    padding: 10px;
  }

  tr td:first-child,
  tr,
  th:first-child {
    background-color: ${(props) => props.theme.bottomColor};
  }

  td:not(:first-child) {
    min-width: 140px;
  }
`;


export const AffiliatedLevelContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  @media (min-width: 1536px) {
    gap: 0;
  }
`;

export const AffiliatedLevel = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 40%;
  align-items: center;

  @media (min-width: 600px) {
    flex-basis: 20%;
  }
  span {
    display: flex;
    svg {
      color: ${(props) => props.theme.primary};
    }
  }

  span ~ svg {
    font-size: 1.7em;
  }

  div {
    text-align: center;
    border-top: 2px solid ${(props) => props.theme.selectColor};
    span:nth-child(2) {
      color: ${(props) => props.theme.primary};
    }
    span:nth-child(3) {
      color: #ff9800;
    }
  }
`;